/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../services.module.ts" />

module Meevo.Plugins.Services {
    class ServiceStepModalController {

        static $inject = ["context", "serviceStep", "$mdDialog", "meevo.components.modal.ModalService", "dataService"]
        public context: any;
        public serviceStep: any;
        protected step: any;
        protected editMode: boolean;
        public readOnly: boolean;
        public isAccessible: boolean;
        public dataService: Meevo.Components.BaseClasses.IDataService;
        public showIncludeProductivityCal: boolean;
        public showcleanFlag: boolean;
        public totalSteps: number;

        constructor(context: any, serviceStep: any, private $mdDialog: ng.material.IDialogService, protected modalService: Meevo.Components.Modal.IModalService, dataService: Meevo.Components.BaseClasses.IDataService) {
            var stepNumber = 1;
            this.readOnly = context.isReadonly;
            this.isAccessible = context.isAccessible;
            this.context = context;
            this.dataService = dataService;

            if (this.context.selectedSection.model.serviceSteps && this.context.selectedSection.model.serviceSteps.length)
                stepNumber = this.context.selectedSection.model.serviceSteps.length + 1;
            this.serviceStep = serviceStep;
            this.totalSteps = this.context.selectedSection.model.serviceSteps.length;
            this.showcleanFlag = false;
            this.step = {
                stepTypeDisplay: "",
                equipments: [],
                minutes: 0,
                isEmployeeRequired: false,
                stepType: 99,
                stepNumber: stepNumber,
                objectState: <number>Model.ObjectStateEnum.Active
            }
            if (serviceStep) {
                this.step = angular.copy(serviceStep);
                this.editMode = true;

                if (this.context.selectedSection.model.serviceSteps[this.totalSteps - 1].stepNumber === this.step.stepNumber && this.totalSteps !== 1)
                {
                    this.showIncludeProductivityCal = true;
                    this.showcleanFlag = true;
                    if (serviceStep.stepType == Meevo.Model.ServiceStepTypeEnum.Gap)
                        this.showIncludeProductivityCal = false;
                    if (serviceStep.stepType == Meevo.Model.ServiceStepTypeEnum.Resource) {
                        this.showIncludeProductivityCal = false;
                        this.showcleanFlag = false;
                    }

                }
            }
            if (serviceStep == undefined && this.totalSteps !== 0) {
                this.showIncludeProductivityCal = true;
                this.showcleanFlag = true;
            }
        }

        apply = (arr: any) => {

            if (this.editMode) {
                for (var i = 0; i < this.context.selectedSection.model.serviceSteps.length; i++) {
                    if (this.context.selectedSection.model.serviceSteps[i].stepNumber === this.step.stepNumber) {
                        if ((this.context.selectedSection.model.serviceSteps[i].stepType != this.step.stepType) || (this.context.selectedSection.model.serviceSteps[i].isCleanupStep != this.step.isCleanupStep)) {
                        delete this.step["id"];
                        }
                    this.context.selectedSection.model.serviceSteps[i] = this.step;
                    }
                }
            }
            else {
                if (!Array.isArray(this.context.selectedSection.model.serviceSteps))
                    this.context.selectedSection.model.serviceSteps = new Array();
                this.context.selectedSection.model.serviceSteps.push(this.step);
                this.context.reorderSteps(this.context.selectedSection.model.serviceSteps);

            }
            this.$mdDialog.hide();

            if (this.step.stepType == Meevo.Model.ServiceStepTypeEnum.Resource)
                this.context.validateResourceStep(this.step);
        }

        cancel = () => {
            this.$mdDialog.hide();
        }


        stepAction(): void {
            if (this.totalSteps <= this.step.stepNumber && this.step.stepNumber !== 1)
            {
                this.showIncludeProductivityCal = true;
                this.showcleanFlag = true;
            }
            if (this.step.stepType == Meevo.Model.ServiceStepTypeEnum.Resource)
            {
                this.showIncludeProductivityCal = false;
                this.step.includeInProductivity = false;
                this.showcleanFlag = false;
                this.step.isCleanupStep = false;
            }
            else if (this.step.stepType == Meevo.Model.ServiceStepTypeEnum.Gap)
            {
                    this.showIncludeProductivityCal = false;
                    this.step.includeInProductivity = false;
            }           
        }

        stepCleanUp(): void {
            if (this.step.stepType == Meevo.Model.ServiceStepTypeEnum.Gap) {
                this.showIncludeProductivityCal = false;
                this.step.includeInProductivity = false;
            }
            if (this.step.stepType == Meevo.Model.ServiceStepTypeEnum.Servicing || this.step.stepType == Meevo.Model.ServiceStepTypeEnum.Other)
            {
                if (this.step.isCleanupStep === false)
                    this.step.includeInProductivity = false;
                else 
                    this.showIncludeProductivityCal = true;                
            }
        }
    }

    angular.module("meevo.plugins.services")
        .controller("meevo.plugins.services.ServiceStepModalController", ServiceStepModalController);
}